import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X, Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waHref } from "@/lib/api";

export function FloatingWidget() {
  const [open, setOpen] = useState(false);
  const { settings } = useSite();
  const wa = settings?.whatsapp || "+33769017322";
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-widget">
      {open && (
        <div className="fade-up w-64 rounded-2xl border border-black/5 bg-white p-4 shadow-2xl" style={{ animationDuration: ".3s" }}>
          <p className="font-display text-lg font-bold uppercase text-ink">Parlons-en</p>
          <p className="mb-3 text-sm text-neutral-600">Une question ? Écrivez-nous.</p>
          <a href={waHref(wa, "Bonjour MA LEBA, ")} target="_blank" rel="noopener noreferrer" data-testid="widget-whatsapp-link"
            className="mb-2 flex items-center gap-2 rounded-lg bg-[#25D366] px-4 py-3 font-semibold text-white transition-colors hover:bg-[#1eb556]">
            <MessageCircle className="h-5 w-5" /> Écrire sur WhatsApp
          </a>
          <Link to="/contact" onClick={() => setOpen(false)} data-testid="widget-contact-link"
            className="flex items-center gap-2 rounded-lg bg-ink px-4 py-3 font-semibold text-white transition-colors hover:bg-neutral-800">
            <Mail className="h-5 w-5" /> Formulaire de contact
          </Link>
        </div>
      )}
      <button onClick={() => setOpen(!open)} aria-expanded={open} aria-label="Ouvrir la discussion" data-testid="widget-toggle"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform hover:scale-105">
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-7 w-7" />}
      </button>
    </div>
  );
}
